import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../CSS/Home.css';

import HighlightSection from '../components/HighlightSection.js';
import ContactForm from '../components/contactForm';
import useScrollFadeIn from '../components/useScrollFadeIn.js';

import reactIcon from '../assets/icons/react.svg';
import jsIcon from '../assets/icons/js.svg';
import wpIcon from '../assets/icons/wordpress.svg';
import psIcon from '../assets/icons/photoshop.svg';
import prIcon from '../assets/icons/premiere.svg';
import cssIcon from '../assets/icons/css.svg';
import htmlIcon from '../assets/icons/html5.svg';

import basedIcon from '../assets/icons/location.svg';
import briefcaseIcon from '../assets/icons/briefcase.svg';

function Home() {
  const { t } = useTranslation();
  const [headerRef, headerVisible] = useScrollFadeIn();
  const [skillsRef, skillsVisible] = useScrollFadeIn();
  const [highlightRef, highlightVisible] = useScrollFadeIn();
  const [contactRef, contactVisible] = useScrollFadeIn();

  useEffect(() => {
    const shouldScroll = sessionStorage.getItem('scrollToContact');
    if (shouldScroll === 'true') {
      // Add a delay to ensure any scroll-to-top effects have completed
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
        sessionStorage.removeItem('scrollToContact');
      }, 100);
    }
  }, []);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="d-none d-xl-block col-xl-12"></div>

        <div className="col-11 col-sm-12 col-xl-12 px-4 px-sxm px-sm-1 px-md-5">
          <div
            ref={headerRef}
            className={`header-section fade-in-section ${headerVisible ? 'visible' : ''}`}
          >
            <h1 className="header-name">
              Akseli <span className="d-block d-xl-inline" /> Rajahalme 
            </h1>

            <div className="briefcase">
              <div className="d-none d-md-flex align-items-center">
                <img src={briefcaseIcon} alt="Briefcase" />
                <span className="subtext">{t('home.profession')}</span>
              </div>
              <div className="d-flex d-md-none flex-column">
                <div className="d-flex align-items-center">
                  <img src={briefcaseIcon} alt="Briefcase" />
                  <span className="subtext">{t('home.professionMobile')}</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="subtextUI">{t('home.professionMobile2')}</span>
                </div>
              </div>
            </div>

            <div className="location">
              <img src={basedIcon} alt="Location" />
              <span>{t('home.location')}</span>
            </div>
          </div>

          <div
            ref={skillsRef}
            className={`skills-section fade-in-section ${skillsVisible ? 'visible' : ''}`}
          >
            <p className="subtext mb-3">{t('home.skillsTitle')}</p>
            <div className="skills-grid">
              <div className="skill-badge">
                <img src={reactIcon} alt="React" />
                <span>React</span>
              </div>
              <div className="skill-badge">
                <img src={wpIcon} alt="Wordpress" />
                <span>Wordpress</span>
              </div>
              <div className="skill-badge">
                <img src={jsIcon} alt="Javascript" />
                <span>Javascript</span>
              </div>
              <div className="skill-badge">
                <img src={htmlIcon} alt="HTML5" />
                <span>HTML5</span>
              </div>
              <div className="skill-badge">
                <img src={prIcon} alt="Premiere Pro" />
                <span>Premiere Pro</span>
              </div>
              <div className="skill-badge">
                <img src={cssIcon} alt="CSS" />
                <span>CSS</span>
              </div>
              <div className="skill-badge">
                <img src={psIcon} alt="Photoshop" />
                <span>Photoshop</span>
              </div>
            </div>
          </div>

          <div
            ref={highlightRef}
            className={`fade-in-section ${highlightVisible ? 'visible' : ''} d-none d-xl-block`}
          >
            <HighlightSection />
          </div>

          <div
            ref={contactRef}
            id="contact"
            className={`contactForm fade-in-section ${contactVisible ? 'visible' : ''}`}
          >
            <h2 className="header-name">{t('home.contactTitle')}</h2>
            <p className="subtext mb-4">
              {t('home.email')}<br />
              {t('home.phone')}
            </p>
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;